
import { Options, Vue } from 'vue-class-component';
import NavigationService from "@/services/NavigationService";
import RegionService from "@/services/RegionService";
import { RecordIdentifier } from "@/data/global";
import { RegionEnrollment as RegionEnrollmentDTO } from "@/data/region";
import Alert from "@/components/Alert.vue";
import EventBusService from "@/services/EventBusService";
//import AuthService from "@/services/AuthService";
//import UrlService from "@/services/UrlService";

@Options({
    props: {
        regionId: {
            type: [Number, String],
            required: true,
        },
    },
    components: {
        Alert,
    },
    emits: [
        'enrollment',
        'withdrawal',
    ],
})
export default class RegionEnrollment extends Vue {
    regionId!: RecordIdentifier

    loggedIn = false
    loginOpen = false

    error = false

    loading = true
    loaded = false

    loadingEnroll = false
    loadingWithdraw = false

    enrollment: RegionEnrollmentDTO|null = null

    get isEnrolled() {
        return !!this.enrollment;
    }

    get iconClass() {
        return {
            /*
            'fa-check-circle': this.isEnrolled,
            'fa-clock': !this.isEnrolled && this.isWaiting,
            'fa-times-circle': !this.isEnrolled && !this.isWaiting,
            'text-success': this.isEnrolled,
            'text-warning': !this.isEnrolled && this.isWaiting,
            'text-danger': !this.isEnrolled && !this.isWaiting,
            */
        };
    }

    get registerWithRegionPrefilledUrl() {
        return NavigationService.buildRouteUrl('register', { region: this.regionId });
    }

    onEnrollmentStatusChange() {
        this.$emit('enrollmentStatusChange');
        this.loadEnrollmentStatus();
    }

    loadEnrollmentStatus() {
        this.loading = true;
        return RegionService.getRegionEnrollmentStatus(this.regionId).then(result => {
            this.loggedIn = true;

            this.enrollment = result.data?.data || null;

            this.error = false;
        }).catch(error => {
            this.enrollment = null;
            if( error.response.status === 401 ) {
                this.loggedIn = false;
                return;
            }
            this.error = true;
        }).finally(() => {
            this.loading = false;
            this.loaded = true;
        });
    }

    onPerformEnrollment() {
        this.loadingEnroll = true;
        return RegionService.enrollRegion(this.regionId).then(result => {
            // this.loggedIn = true;

            EventBusService.$notification({
                type: 'success',
                message: 'Deine Standortanmeldung war erfolgreich.',
            });

            this.$emit('enrollment');
            EventBusService.$emit('user.regions.enrollment:changed');
            //this.result = result.data?.data || null;

            this.loadEnrollmentStatus();

            //this.error = false;
            //this.loaded = true;
        }).catch(error => {
            EventBusService.$notification({
                type: 'error',
                message: error.response.data?.error || 'Bei deiner Standortanmeldung ist ein Fehler aufgetreten.',
            });
            console.log(error.response.data);
            //this.result = null;
            if( error.response.status === 401 ) {
                // this.loggedIn = false;
                return;
            }
            //this.error = true;
        }).finally(() => this.loadingEnroll = false);
    }

    onPerformWithdrawal() {
        this.loadingWithdraw = true;
        return RegionService.withdrawRegion(this.regionId).then(result => {
            // this.loggedIn = true;

            EventBusService.$notification({
                type: 'success',
                message: 'Deine Standortabmeldung war erfolgreich.',
            });

            this.$emit('enrollment');
            EventBusService.$emit('user.regions.enrollment:changed');
            //this.result = result.data?.data || null;

            this.loadEnrollmentStatus();

            //this.error = false;
            //this.loaded = true;
        }).catch(error => {
            EventBusService.$notification({
                type: 'error',
                message: error.response.data?.error || 'Bei deiner Standortabmeldung ist ein Fehler aufgetreten.',
            });
            console.log(error.response.data);
            //this.result = null;
            if( error.response.status === 401 ) {
                // this.loggedIn = false;
                return;
            }
            //this.error = true;
        }).finally(() => this.loadingWithdraw = false);
    }

    mounted() {
        this.loadEnrollmentStatus();
    }
}
